export const CommonObject = {
  CompanyName: 
    {
      PVG: "Prime Ventures Global",
      CAC: "ClickaCook",
      IFMS: "Integrated Facility Management Solutions",
    },
  CompanyDetails: 
    {
      MailID: {
        info:"info@primeventuresglobal.com",
        HR: "hr@primeventuresglobal.com",
        Support: "support@primeventuresglobal.com",
      },
      Address: {
        ClickaCook: "ClickaCook,3 Hornton Place, Kensington, London",
        IFMS: "86/87 3rd ,Street SBI Colony ,Virugambakkam ,Chennai-92,+91 7299982022",
      },
      PhoneNumber: "+91 7299982022",
    },
  
};
